import { get } from 'lodash';
import { withBarWrapper } from '../HOCs/BarWrapper';
import { FALLBACK_PRICE } from '../../../common/constants';

function PriceBar({ product }) {
    let price = get(product, 'customValues.price', '');
    let priceLabel = '-';

    if (price) {
        price = parseFloat(price);
        priceLabel = price === FALLBACK_PRICE ? '$' : `$${price}`;
    }

    return `List Price: ${priceLabel}`;
}

export default withBarWrapper(PriceBar, {
    customStyles: {
        height: '6.3mm',
        lineHeight: '6.3mm',
        fontWeight: 'bold',
    },
});
